import { register, getPrefix, getCookie } from '../../../Utils'

const NewsletterPopup = el => {
  const prefix = getPrefix(el)
  const backdrop = el.querySelector(`.${prefix}backdrop`)
  const closer = el.querySelector(`.${prefix}close-button`)
  const cookieName = 'newsletter_popup_displayed'
  const expiryDate = new Date()
  expiryDate.setMonth(expiryDate.getMonth() + 1) // 1 month after setting
  let timer

  const openPopup = () => {
    el.classList.add(`${prefix}is--open`)
  }

  const closePopup = () => {
    el.classList.remove(`${prefix}is--open`)
    setCookie()
    clearTimeout(timer)
    document.removeEventListener('mouseleave', openPopup)
  }

  const setCookie = () => {
    document.cookie = cookieName + '=true; expires=' + expiryDate.toUTCString() + '; path=/; SameSite=lax; Secure'
  }

  backdrop.addEventListener('click', closePopup)
  closer.addEventListener('click', closePopup)

  const startTimer = () => {
    timer = setTimeout(() => {
      openPopup()
    }, 30000)
  }

  if (!getCookie(cookieName)) {
    startTimer()
    document.addEventListener('mouseleave', openPopup)
  }
}

register('NewsletterPopup', NewsletterPopup)
